import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { SalesHttpService } from '../_services/sales-http.service';

export class MachineSalesDataSource implements DataSource<any> {
	private MacSalesListSubject = new BehaviorSubject<any[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);

	public loading$ = this.loadingSubject.asObservable();

	empty = false;

	private countSubject = new BehaviorSubject<number>(0);
	public counter$ = this.countSubject.asObservable();

	private lastEvalKeySubject = new BehaviorSubject<any>({});
	public lastEvalKey$ = this.lastEvalKeySubject.asObservable();

	constructor(private http: SalesHttpService) {}

	connect(collectionViewer: CollectionViewer): Observable<any[]> {
		return this.MacSalesListSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.MacSalesListSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
	}

	loadMacSalesList(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);
		this.http.getMachineSales(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(macSaleList => {
			this.loadingSubject.next(false);
			if (macSaleList.cnt === 0) {
				this.empty = true;
			}
			this.MacSalesListSubject.next(macSaleList.payload);
			this.countSubject.next(Math.ceil(macSaleList.cnt));
		});
	}
}
